import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import '@aws-amplify/ui-react/styles.css';
import '../src/config/amplify'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);